export default __webpack_public_path__ + "static/media/max-steiner-orchester.9e6b5d61.jpg";